export default class CustomerLimitFiltersModel {
  constructor(obj) {
    obj = obj || {};

    this.startDate = obj.startDate;
    this.endDate = obj.endDate;
    this.idExchangeBank = obj.idExchangeBank;
    this.idCustomer = obj.idCustomer;
  }
}